import { gql } from '@apollo/client'

export const GET_ADMIN_COMPANY_REGIONS = gql`
  query GetAdminCompanyRegions {
    regions {
      id
      name
    }
  }
`
